// extracted by mini-css-extract-plugin
export default {"resetButton":"uniHxaq","highlightedRow":"K5dsbmN","queryName":"HQM59tc","resultsCount":"fIr6Dw0","queryRow":"TtRfU6R"};